const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M33.313 41H7.688A7.687 7.687 0 0 1 0 33.313V7.688A7.687 7.687 0 0 1 7.688 0h25.625A7.687 7.687 0 0 1 41 7.688v25.625A7.687 7.687 0 0 1 33.313 41zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 7.628h-.636V5.086a5.086 5.086 0 1 0-10.171 0v2.542h-.636A1.909 1.909 0 0 0 3 9.536v8.9a1.909 1.909 0 0 0 1.907 1.907H16.35a1.909 1.909 0 0 0 1.907-1.907v-8.9a1.909 1.909 0 0 0-1.907-1.908zM7.238 5.086a3.39 3.39 0 1 1 6.781 0v2.542H7.238zm4.238 9.088V16.1a.848.848 0 0 1-1.7 0v-1.926a1.7 1.7 0 1 1 1.7 0z",
    transform: "translate(9.872 10.137)",
    style: {
      fill: "#faa100"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.05b347c1170037be6560b53b824434a3.svg";
export { ForwardRef as ReactComponent };